<template>
  <div>全局公告组件</div>
</template>

<script>
export default {
  name: 'GTableContent',
};
</script>

<style></style>
